import React from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';

class ConfirmationModalProps {
  title: string;
  buttonText: string;
  mainContent: string | JSX.Element;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  buttonVariant?: 'primary' | 'secondary' | 'tertiary' | 'danger' | undefined;
  hideCancel?: boolean = false;
  disableConfirmation?: boolean = false;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props: ConfirmationModalProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} defaultPadding={false}>
      <div className="confirmation-modal">
        <div className="confirmation-modal__header">
          <h3 className="confirmation-modal__title">{props.title}</h3>{' '}
        </div>

        <div className={`confirmation-modal__content body-14-regular ${props.title ? 'content-border' : ''}`}>
          {props.mainContent}
        </div>
        <div className="confirmation-modal__actions">
          {!props.hideCancel && (
            <Button
              onClick={props.onClose}
              text={'Cancel'}
              size={'medium'}
              variant={'secondary'}
              className="confirmation-modal__actions__cancel"
            />
          )}
          <Button
            onClick={props.onSuccess}
            text={props.buttonText}
            disabled={props.disableConfirmation}
            size={'medium'}
            variant={props.buttonVariant ?? 'primary'}
          />
        </div>
      </div>
    </Modal>
  );
};
